import { Skeleton } from "@mui/material";

interface SkeletonContentCardProps {
  contentFormat?: string;
}

const SkeletonContentCard = ({
  contentFormat = "",
}: SkeletonContentCardProps) => {
  return (
    <div className="bg-secondary-bluegrey-2 flex flex-col justify-start items-start p-[24px_16px] w-full max-h-[200px] gap-2 box-border rounded-2xl overflow-hidden shadow-card">
      <Skeleton
        variant="rectangular"
        width={75}
        height={20}
        style={{ borderRadius: "100px", marginBottom: "8px" }}
      />
      <Skeleton
        variant="rectangular"
        width={120}
        height={16}
        style={{ marginBottom: "8px" }}
      />

      <Skeleton variant="rectangular" width="90%" height={10} />
      <Skeleton variant="rectangular" width="65%" height={10} />
      <Skeleton variant="rectangular" width="80%" height={10} />

      {contentFormat === "playlist" ? (
        <div className="flex justify-start items-center w-full gap-16 mt-4">
          <Skeleton variant="rectangular" width={64} height={40} />
          <Skeleton variant="circular" width={40} height={40} />
          <Skeleton variant="circular" width={40} height={40} />
        </div>
      ) : (
        <div className="flex justify-start items-center w-full gap-16 mt-4">
          <div className="flex flex-col justify-start items-start gap-1">
            <Skeleton variant="rectangular" width={75} height={8} />
            <Skeleton variant="rectangular" width={100} height={16} />
          </div>
          <div className="flex flex-col justify-start items-start gap-1">
            <Skeleton variant="rectangular" width={60} height={8} />
            <Skeleton variant="rectangular" width={140} height={16} />
          </div>
        </div>
      )}
    </div>
  );
};

export default SkeletonContentCard;
